/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CreateManufacturerTargetDto } from '../../models/create-manufacturer-target-dto';
import { ManufacturerTarget } from '../../models/manufacturer-target';

export interface CreateOneBaseMgmtManufacturerTargetControllerManufacturerTarget$Params {
  manufacturerId: number;
      body: CreateManufacturerTargetDto
}

export function createOneBaseMgmtManufacturerTargetControllerManufacturerTarget(http: HttpClient, rootUrl: string, params: CreateOneBaseMgmtManufacturerTargetControllerManufacturerTarget$Params, context?: HttpContext): Observable<StrictHttpResponse<ManufacturerTarget>> {
  const rb = new RequestBuilder(rootUrl, createOneBaseMgmtManufacturerTargetControllerManufacturerTarget.PATH, 'post');
  if (params) {
    rb.path('manufacturerId', params.manufacturerId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ManufacturerTarget>;
    })
  );
}

createOneBaseMgmtManufacturerTargetControllerManufacturerTarget.PATH = '/api/mgmt/manufacturer/{manufacturerId}/targets';
